/**
 * The NFC document chip step (ICAO 9303). The screen is `./DocumentChipStep`;
 * the chip itself is read by the native SDKs (`sdk/`), never in a browser.
 *
 * `DOCUMENT_CHIP_READ` is fired by the SERVER after it verifies the chip
 * (`POST /collection-flow/document-chip`); the events route refuses it from a
 * client. The SPA lists it only so the step renders. `DOCUMENT_CHIP_UNAVAILABLE`
 * is the applicant's own act — this device cannot read the chip, or they
 * choose not to — and the flow decides where it leads.
 */
export const DOCUMENT_CHIP_READ_EVENT = 'DOCUMENT_CHIP_READ';
export const DOCUMENT_CHIP_UNAVAILABLE_EVENT = 'DOCUMENT_CHIP_UNAVAILABLE';
